// Using one file as single source of truth and importing that file for FE use
import {
  networkDirectory as networkDirectoryConnector,
  networkMap as networkMapConnector,
  networksWithProgramAssets as programAssetList,
  networksWithoutCovers as noCoverList,
} from '../../node-utils/networkMap';


export const seoTitleTemplates = {
  1: 'Watch Sports on',
  2: 'Watch News on',
  3: 'Watch',
};

// Used as a lookup for when multiple providerNames point to the same network
export const networkDirectory = networkDirectoryConnector;

export const networkMap = networkMapConnector;

export const hasProgramAssets = programAssetList;

export const hasNoCovers = noCoverList;
